<template>
    <!-- <div class="container client-page-title">
      {{ $t("pages.Client.createTile") }}
    </div> -->

    <div class="container d-flex align-items-center justify-content-between client-page-title">
      <span>{{ $t("pages.Client.createTile") }}</span>
      <div class="blue-btn-container">
        <button type="submit" class="btn-blue mb-2" @click="inputFileClickEvent">
          <i class="scf-dSquare" style="margin-right: 10px; left: 5px; width: 16px;" />
          {{ $t("pages.clientConfiguration.chooseFile") }}
        </button>
        <input
          class="form-control"
          type="file"
          ref="file"
          @change="selectFile"
          style="font-style: italic; display: none;"
          accept="application/x-zip-compressed"
        />
      </div>
      <formModalClientFile :show="showModalFile" :title="$t('pages.Client.LoadFileClientsTitle')"
              :type="'notif'" :class="card-load-title"
              :key="61" :fromPage="pageFrom"  @update:show="cancel">
      </formModalClientFile>

    </div>

  <div>
    <clientForm
      v-if="okParameters"
      :timeZones="timeZones"
      :cultures="cultures"
      :status="status"
      :rgpd="rgpd"
      :apiCurves="apiCurves"
      :availableServices="availableServices"
      :businessActs="businessActs"
      @save="setClient"
      @goToList="goToList"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ClientService from "../../services/ClientService";
import clientForm from "../../forms/ClientForm";
import Swal from "sweetalert2";
import MainService from "../../services/MainService";
import formModalClientFile from "../../components/FormModalClientFile.vue";


export default defineComponent({
  name: "ClientCreate",
  inject: ["accessToken"],
  components: {
    clientForm,
    formModalClientFile
  },
  watch: {
       currentScope(newVal) {
        if (newVal) {
          this.clientService = new ClientService(this.$jwt.token, newVal);
          this.mainService = new MainService(this.$jwt.token, newVal);
        }
      },
      accessToken(newVal) {
        if (newVal) {
          this.clientService = new ClientService(newVal, this.currentScope);
          this.mainService = new MainService(newVal, this.currentScope);
        }
      },
      "$i18n.locale": {
        handler() {
          this.businessActs = this.prepareBusinessActs(this.businessActs);
        }
      },
  },
  data() {
  return {
    clientService: null,
    currentScope: null,
    timeZones: [],
    cultures: [],
    status: null,
    rgpd: null,
    apiCurves: [],
    businessActs: [],
    availableServices: [],
    okParameters: false,

    //File parameters
    enableSend: false,
    errors: [],
    file: null,
    filename: null,
    showModalFile: false,
  };
},
computed: {
    culture() {
      return this.$i18n.locale;
    }
  },
  created() {
    this.clientService = new ClientService(this.$jwt.token, this.$jwt.scope);
    this.currentScope = this.$jwt.scope;
    this.status = this.clientService.getStatus();
    this.rgpd = this.clientService.getRGPD();
  },
  mounted() {
      this.clientService
      .getParameters()
      .then((responseParams) => {
        this.apiCurves = responseParams.clientApiCurves;
        this.timeZones = responseParams.timezones;
        this.cultures = responseParams.clientCultures;
        this.availableServices = responseParams.clientServices;
        this.businessActs = this.prepareBusinessActs(responseParams.businessActs);
        this.okParameters = true;
      })
      .catch((error) => {
        console.log(error);
      });
  },

  methods: {
    prepareBusinessActs(businessActs) {
      if (Array.isArray(businessActs))
        return businessActs.map((ba) => { ba.display = this.$t(`businessActs.${ba.trKey}`); return ba; })
      let transformedBusinessActs = [];
      Object.keys(businessActs).forEach((k) => {
        const item = {
          trKey: k,
          businessAct: businessActs[k],
          display: this.$t(`businessActs.${k}`),
        }
        transformedBusinessActs.push(item);
      });
      return transformedBusinessActs;
    },
    setClient: function (client) {
      // Afficher le message Sweetalert pendant la cru00e9ation
      const loadingSwal = Swal.fire({
        title: this.$t("pages.Client.creatingClient"),
        text: this.$t("pages.Client.pleaseWait"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      // Optimiser les donnu00e9es envoyu00e9es pour u00e9viter l'erreur 413 Payload Too Large
      const optimizedClient = this.optimizeClientData(client);
      
      this.clientService
        .create(optimizedClient)
        .then((response) => {
          // Fermer le message Sweetalert
          loadingSwal.close();
          
          if (response.errorCode !== undefined && response.response == false) {
            // Afficher un message d'erreur spu00e9cifique
            Swal.fire({
              title: "",
              width: 600,
              icon: "error",
              html: this.$t(`pages.Client.${response.errorCode}`, { code: client.externalId }),
            });
          } else {
            // Afficher un message de succu00e8s
            Swal.fire({
              icon: 'success',
              title: this.$t("pages.Client.createSuccess"),
              text: this.$t("pages.Client.clientCreatedSuccessfully"),
              timer: 2000,
              showConfirmButton: false
                   }).then(() => {
              // Rafraîchir la page après le message de succès
            window.location.reload();
            });
            
            // Rediriger vers la liste des clients 
            // setTimeout(() => {
            //   this.goToList();
            // }, 2000);
          }
          console.log(response);
        })
        .catch((error) => {
          // Fermer le message Sweetalert et afficher une erreur
          loadingSwal.close();
          
          Swal.fire({
            icon: 'error',
            title: this.$t("pages.Client.createError"),
            text: error.message || this.$t("pages.Client.errorOccurred"),
          });
          
          console.log(error);
        });
    },

    goToList: function () {
      this.$emit("closeCreate");
    },

    // Mu00e9thode pour optimiser les donnu00e9es du client avant l'envoi
    optimizeClientData: function(client) {
      // Cru00e9er une copie du client pour ne pas modifier l'original
      const optimizedClient = { ...client };
      
      // Convertir la configuration en chau00eene JSON si c'est un objet
      if (typeof optimizedClient.clientConfiguration === 'object') {
        optimizedClient.clientConfiguration = JSON.stringify(optimizedClient.clientConfiguration);
      }
      
      // Supprimer les donnu00e9es volumineuses qui ne sont pas nu00e9cessaires pour la cru00e9ation
      // ou qui peuvent u00eatre ru00e9cupu00e9ru00e9es autrement par le serveur
      if (optimizedClient.hierarchyContent && optimizedClient.hierarchyContent.length > 0) {
        // Si hierarchyContent est trop volumineux, ne garder que les informations essentielles
        optimizedClient.hierarchyContent = optimizedClient.hierarchyContent.map(item => ({
          id: item.id,
          levelsNumber: item.levelsNumber,
          // Garder d'autres champs essentiels selon votre logique mu00e9tier
        }));
      }
      
      // Supprimer les propriu00e9tu00e9s qui ne sont pas nu00e9cessaires pour la cru00e9ation
      delete optimizedClient._links;
      delete optimizedClient._embedded;
      
      // Si d'autres propriu00e9tu00e9s volumineuses existent, les traiter ici
      
      return optimizedClient;
    },

    //File

    // inputFileClickEvent() {
    //   console.log(this.appVersion);
    //   const elem = this.$refs.file;

    //   elem.click();
    // },

    inputFileClickEvent() {
      this.showModalFile = true
   },


    progressBar(progressEvent) {
      this.uploadPercentage = parseInt(
        Math.round((progressEvent.loaded / progressEvent.total) * 100)
      );
    },

    intialization() {
      (this.enableSend = false),
        (this.errors = []),
        (this.file = ""),
        (this.filename = "")
    },

    cancel() {
      this.intialization();
      this.$refs.file.value = null;
      this.showModalFile = false;
    },
  }

});
</script>

<style scoped src="../../assets/css/client.css"></style>
